// Bausteine, die eine Seite erst beim Öffnen nachlädt (3D-Viewer,
// Druckplatte, Druckermodell). Nach einem Deploy gibt es die alte Datei
// nicht mehr: die offene Seite fragt nach einem Namen, den der neue Build
// nicht kennt (Tim 24.10.2026: „Der Viewer ließ sich nicht laden" -- Seite
// vor dem Deploy um 18:27 offen, G-Code danach geöffnet).
//
// Wie eine ganze Seite (App.svelte, reloadForBrokenChunk): einmal neu
// laden. Halten ungespeicherte Eingaben das auf oder griff der Schutz gegen
// Neulade-Schleifen, wirft ladeBaustein -- der Aufrufer zeigt seinen Fehler
// und den Knopf „Neu laden" (bausteinFehlt).

import { reloadForBrokenChunk } from "./pwa.svelte";

/** Wirft BausteinFehlt, wenn der Baustein nicht kommt und nicht neu geladen wird. */
export class BausteinFehlt extends Error {}

export async function ladeBaustein<T>(name: string, laden: () => Promise<T>): Promise<T> {
  try {
    return await laden();
  } catch (e) {
    // Neu laden läuft: nichts anzeigen, gleich ist die neue Seite da.
    if (reloadForBrokenChunk(`baustein ${name}: ${String(e)}`)) return new Promise<T>(() => {});
    throw new BausteinFehlt(String(e));
  }
}
